import React from 'react';
import PropTypes from 'prop-types';
import { BaasicDropdownTemplate } from 'themes/components';
import { observer } from 'mobx-react';

const BaasicDropdown = observer(props => {
	return <BaasicDropdownTemplate {...props} />;
});

BaasicDropdown.propTypes = {
	dropdownStore: PropTypes.object,
	isClearable: PropTypes.bool,
	placeholder: PropTypes.string,
	className: PropTypes.string,
	classNamePrefix: PropTypes.string,
	menuPlacement: PropTypes.string,
	label: PropTypes.string,
	autoFocus: PropTypes.bool,
	additionalLabel: PropTypes.elementType,
	isDisabled: PropTypes.bool,
	menuIsOpen: PropTypes.bool,
	showLabel: PropTypes.bool,
};

BaasicDropdown.defaultProps = {
	className: 'flex--grow--1',
	classNamePrefix: 'react-select',
	showLabel: true,
};

export default BaasicDropdown;
